<template>
  <div class="message-file-wigdet">
    <div @click="addFile()">
      <slot></slot>
    </div>

    <file-upload
      ref="upload"
      input-id="feed-file-input"
      v-model="files"
      name="file"
      :multiple="false"
      :post-action="upload_url"
      :maximum="8"
      @input-file="inputFile"
      @input-filter="inputFilter"
      @input="updatetValue"
      :headers="{
        Authorization: 'Bearer ' + authToken,
      }"
    >
    </file-upload>
  </div>
</template>

<script>
import { API } from "@/Store/variable.js";
import { eventBus } from "../main";
export default {
  name: "add-post-modal",
  components: {},
  props: {},
  data() {
    return {
      files: [],
      authToken: sessionStorage.authToken,
      upload_url: API + "/message/upload",
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("startUpload", () => {
      vm.startUpload();
    });
  },
  methods: {
    startUpload() {
      let vm = this;
      if (vm.$refs.upload != undefined) {
        vm.$refs.upload.active = true;
      }
    },
    removeFile(file) {
      let vm = this;
      vm.$refs.upload.remove(file);
    },
    addFile() {
      let vm = this;
      vm.$refs.upload.clear();
      let file_el = document.querySelector("#feed-file-input");
      file_el.click();
    },
    inputFile(newFile, oldFile) {},
    inputFilter(newFile, oldFile, prevent) {
      let vm = this;
      if (newFile && !oldFile) {
        if (
          vm.isVideo(newFile.name) ||
          vm.isImage(newFile.name) ||
          vm.isDocumentFile(newFile.name)
        ) {
          if (vm.files.map((item) => item.name).includes(newFile.name)) {
            return prevent();
          }
          newFile.blob = "";
          let URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file);
          }
          let file_data = {
            file_type: "",
            file: null,
            image: null,
            video: null,
            file_name: "",
          };

          if (vm.isVideo(newFile.name)) {
            file_data.file_type = "video";
            file_data.video = newFile;
          } else if (vm.isImage(newFile.name)) {
            file_data.file_type = "image";
            file_data.image = newFile;
          } else if (vm.isDocumentFile(newFile.name)) {
            file_data.file_type = "file";
            file_data.file = newFile;
          }
          file_data.file_name = newFile.name;
          vm.$emit("fileSelected", file_data);
        }
      }
      if (newFile && oldFile) {
        if (!newFile.version) {
          newFile.version = 0;
        }
        newFile.version++;
      }
    },
    updatetValue(value) {
      let vm = this;
      if (vm.files.length > 0) {
        if (vm.$refs.upload && vm.$refs.upload.uploaded) {
          setTimeout(() => {
            vm.$emit("uploadCompleted", value);
          }, 500);
        } else {
          vm.$emit("uploadProgress", value);
        }
      }
    },
    GetExt(file) {
      return /(?:\.([^.]+))?$/.exec(file)[1];
    },
    isVideo(filename) {
      return /\.(webm|mp4|mkv)$/i.test(filename);
    },
    isImage(filename) {
      return /\.(jpeg|jpe|jpg|gif|png|webp|svg)$/i.test(filename);
    },
    isDocumentFile(filename) {
      return /\.(pdf|doc|docx|odt|xls|xlsx|ods|ppt|pptx|txt)$/i.test(filename);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
</style>

